const APP_VERSION = '1781129994074';
export default APP_VERSION;
